import { useRef, useEffect } from 'react'

import type { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'
import Icon from '@space-lib/components/icon'
import clsx from 'clsx'

import styled from 'styled-components'

import { IMG_OBJECT_FIT } from './constants'

import '@hotmart/cosmos/dist/avatar'

export type AvatarProps = {
  initialLetters?: string
  urlAvatar?: string
  icon?: IconDefinition
  className?: string
  onClick?: () => void
}

const IconUser = styled(Icon)`
  height: var(--spacer-3);
`

const Avatar = ({ initialLetters, urlAvatar, icon, className, onClick }: AvatarProps) => {
  const avatarRef = useRef<HTMLDivElement>(null)
  const avatarClass = clsx('hot-avatar--circle', '_text-uppercase', '_bg-gray-200', className)
  const dataTest = 'avatar'

  useEffect(() => {
    if (avatarRef.current) {
      const avatar = avatarRef.current
      const imgElement = avatar?.querySelector('img') as HTMLImageElement

      imgElement.setAttribute('role', 'img')
      imgElement.style.objectFit = IMG_OBJECT_FIT
    }
  }, [urlAvatar])

  const handleClick = () => onClick && onClick()

  return urlAvatar ? (
    <hot-avatar
      data-test={dataTest}
      ref={avatarRef}
      class={avatarClass}
      src={urlAvatar}
      translate='no'
      onClick={handleClick}
    />
  ) : (
    <hot-avatar data-test={dataTest} class={avatarClass} translate='no' onClick={handleClick}>
      {initialLetters ? (
        <span>{initialLetters}</span>
      ) : (
        <IconUser data-test='icon-user' icon={icon as IconProp} />
      )}
    </hot-avatar>
  )
}

export default Avatar
